import FlexibleLogo from './FlexibleLogo';

export default FlexibleLogo;
